import React from "react";
import Alert from "react-bootstrap/Alert";
import { Button, Modal } from "react-bootstrap";

const LowWalletBalance = ({ isOpen, toggleModal }) => {
  return (
    <Modal
      size="lg"
      show={isOpen}
      onHide={toggleModal}
      className={`verify light`}
    >
      <Modal.Body className="mb-4">
        <h2 className="text-center mt-4 bold mb-4">You're wallet balance is low!</h2>
      </Modal.Body>
      <div className="footer">
        <Button variant="default" onClick={toggleModal}>
          Close
        </Button>
      </div>
    </Modal>
  );
};

export default LowWalletBalance;
